import React from "react"
import { Filters } from "../notifications/Filters"

export const NotificationFilterModal = () => {
	return (
		<Filters/>
	)
}


